import React from 'react';
import { IAlertaInconsistencia, IRegistroCircularizacao } from '../interfaces/ICircularizacao';

interface Props {
  alertas: IAlertaInconsistencia[];
  registros: IRegistroCircularizacao[];
}

// Seção 12.6 — "Alertas de inconsistência": duplicidade, CNPJ inválido, contato principal
// ausente, e-mail ausente, prazo ausente, carta preparada para registro alterado depois.
const AlertasInconsistenciaPanel: React.FC<Props> = ({ alertas, registros }) => {
  if (alertas.length === 0) return null;

  const nomeDoRegistro = (registroId: string) =>
    registros.find((r) => r.id === registroId)?.razaoSocialExibicao ?? 'Empresa';

  return (
    <div className='circ-alertas-painel'>
      <div className='circ-alertas-painel-titulo'>
        <i className='bi bi-exclamation-triangle-fill me-1' />
        {alertas.length} alerta{alertas.length === 1 ? '' : 's'} de inconsistência
      </div>
      {alertas.map((alerta, idx) => (
        <div key={`${alerta.registroId}-${alerta.tipo}-${idx}`} className='circ-alerta-item'>
          <strong>{nomeDoRegistro(alerta.registroId)}:</strong> {alerta.mensagem}
        </div>
      ))}
    </div>
  );
};

export default AlertasInconsistenciaPanel;
